import getMailTipsViewStateMapFromRecipientEmailAddress from 'owa-mail-tips/lib/utils/getMailTipsViewStateMapFromRecipientEmailAddress';
import getFromAddress from '../utils/getFromAddress';
import type { MailTipsViewStateMap } from 'owa-mail-tips/lib/datapoints';
import getAttendeesAndLocationsAsEmailAddresses from './getAttendeesAndLocationsAsEmailAddresses';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Returns MailTipsViewStateMap for the recipient email addresses
 * @param event CalendarEvent
 */
export default function getMailTipsViewStateMap(
    event: CalendarEvent,
    formId: string
): MailTipsViewStateMap {
    let mailTipsViewStateMap = {};
    // Log mailtips datapoint getFromAddress
    const fromEmailAddress = getFromAddress(formId, event.Organizer);
    if (fromEmailAddress) {
        // Log datapoint
        mailTipsViewStateMap = getMailTipsViewStateMapFromRecipientEmailAddress(
            getAttendeesAndLocationsAsEmailAddresses(event),
            fromEmailAddress
        );
    }
    return mailTipsViewStateMap;
}
